import {DomSanitizer} from '@angular/platform-browser';
import {PipeTransform, Pipe} from '@angular/core';
import { unescape } from 'src/app/utils';

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {
  }
  transform(value) {
    // This step is needed because linkify escapes html characters 
    const converted = unescape(value);
    return this.sanitized.bypassSecurityTrustHtml(converted);
  }
}